import { Language } from '@/types/i18n';
import { AddressDetails } from '@/types/user';

import { getDisplayCountryName } from '@/utils/user';

interface FormattedAddressProps {
  address?: AddressDetails;
  language?: Language;
}

export function FormattedAddress({
  address,
  language,
}: Readonly<FormattedAddressProps>) {
  if (!address) return null;

  const lines: string[] = [];

  const line1 = [address.line1, address.line2].filter(Boolean).join(' ');
  if (line1) lines.push(line1);

  const line2 = [address.city, address.state, address.zip]
    .filter(Boolean)
    .join(', ');
  if (line2) lines.push(line2);

  const countryName = getDisplayCountryName(address.country, language);
  if (countryName) lines.push(countryName);

  return (
    <>
      {lines.map((line, i) => (
        <span key={`${i}-${line}`}>
          {line}
          {i < lines.length - 1 && <br />}
        </span>
      ))}
    </>
  );
}
